export default {"src":"/_next/static/media/request-up-medium.c25bc20d.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};